import { createAction, props } from "@ngrx/store";
import { PaginationRequest } from "src/app/models/common/paginationRequest";
import { VehicleExtendedDTO } from "src/app/models/Vehicles/VehicleExtendedDTO";
import { VehicleDTO } from "src/app/models/Vehicles/VehicleDTO";

export const loadVehicles = createAction(
  "[Vehicles] Load All Vehicles Action",
  props<{ response: any[] }>()
);
export const createVehicle = createAction(
  "[Vehicles] Create Vehicle Action",
  props<{ vehicle: VehicleDTO }>()
);
export const updateVehicle = createAction(
  "[Vehicles] Update Vehicle Action",
  props<{ vehicle: VehicleDTO }>()
);
export const getVehicle = createAction(
  "[Vehicles] Get a Vehicle by code Action",
  props<{ vehicleCode: string }>()
);
export const setVehicle = createAction(
  "[Vehicles] Set Vehicle Action",
  props<{ vehicle: VehicleExtendedDTO }>()
);
export const getVehicleList = createAction(
  "[Vehicles] Get All Vehicle List Action",
  props<{ options: any }>()
); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadVehicleList = createAction(
  "[Vehicles] Load All Vehicle List Action",
  props<{ response: any[] }>()
);

// Vehicles Table Configuration Settings
export const getVehicleTableConfig = createAction(
  "[Vehicles] Get Vehicle Table Configuration Action",
  props<{ options: any }>()
);
export const loadVehicleTableConfig = createAction(
  "[Vehicles] Load Vehicle Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveVehicleTableConfig = createAction(
  "[Vehicles] Save Vehicle Table Configuration Action",
  props<{ config: any }>()
);

export const resetVehicle = createAction("[Vehicles] Reset Vehicle Action");
// Loading Actions
export const getLoadingVehiclesState = createAction(
  "[Vehicles] Get Vehicles Loading State Action"
);
export const setLoadingVehiclesStartState = createAction(
  "[Vehicles] Set Vehicles Loading Start State Action"
);
export const setLoadingVehiclesEndState = createAction(
  "[Vehicles] Set Vehicles Loading End State Action"
);
// ProductGroups
export const getProductGroups = createAction(
  "[Vehicles] Get All Vehicles ProductGroups Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadProductGroups = createAction(
  "[Vehicles] Load All Vehicles ProductGroups Action",
  props<{ response: any[] }>()
);
// Categories
export const getVehicleCategoriesByUsage = createAction(
  "[Vehicles] Get All Categories by Usage Action",
  props<{ pageReq: PaginationRequest; usageCode: string }>()
);
export const loadVehicleCategoriesByUsage = createAction(
  "[Vehicles] Load All Categories by Usage Action",
  props<{ response: any[] }>()
);
export const getVehicleCategories = createAction(
  "[Vehicles] Get All Categories by Category Code Action",
  props<{ categoryCode: string }>()
);
export const loadVehicleCategories = createAction(
  "[Vehicles] Load All Categories by Category Code Action",
  props<{ response: any[] }>()
);
export const getVehicleCategoryElements = createAction(
  "[Vehicles] Get All Category Elements by Category Code Action",
  props<{ categoryCode: string }>()
);
export const loadVehicleCategoryElements = createAction(
  "[Vehicles] Load All Category Elements by Category Code Action",
  props<{ response: any[] }>()
);
export const getVehicleOptionalCategoriesByUsage = createAction(
  "[Vehicles] Get All OptionalCategories by Usage Action",
  props<{ pageReq: PaginationRequest; usageCode: string }>()
);
export const loadVehicleOptionalCategoriesByUsage = createAction(
  "[Vehicles] Load All OptionalCategories by Usage Action",
  props<{ response: any[] }>()
);
// Categories and Properties for the grids
export const getVehicleCategoriesForListByUsage = createAction(
  "[Vehicles] Get All Categories for the List by Usage Action",
  props<{ pageReq: PaginationRequest; usageCode: string }>()
);
export const loadVehicleCategoriesForListByUsage = createAction(
  "[Vehicles] Load All Categories for the List by Usage Action",
  props<{ response: any[] }>()
);
export const getVehiclePropertiesForListByUsage = createAction(
  "[Vehicles] Get All Properties for the List by Usage Action",
  props<{ pageReq: PaginationRequest; usageCode: string }>()
);
export const loadVehiclePropertiesForListByUsage = createAction(
  "[Vehicles] Load All Properties for the List by Usage Action",
  props<{ response: any[] }>()
);
// Properties
export const getVehiclePropertiesByUsage = createAction(
  "[Vehicles] Get All Properties by Usage Action",
  props<{ pageReq: PaginationRequest; usageCode: string }>()
);
export const loadVehiclePropertiesByUsage = createAction(
  "[Vehicles] Load All Properties by Usage Action",
  props<{ response: any[] }>()
);
export const getVehicleOptionalPropertiesByUsage = createAction(
  "[Vehicles] Get All Optional Properties by Usage Action",
  props<{ pageReq: PaginationRequest; usageCode: string }>()
);
export const loadVehicleOptionalPropertiesByUsage = createAction(
  "[Vehicles] Load All Optional Properties by Usage Action",
  props<{ response: any[] }>()
);
// Vehicle attributes
// Brand
export const getBrands = createAction(
  "[Vehicles] Get All Vehicle Brands Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadBrands = createAction(
  "[Vehicles] Load All Vehicle Brands Action",
  props<{ response: any[] }>()
);
// Model
export const getModels = createAction(
  "[Vehicles] Get All Vehicle Models Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadModels = createAction(
  "[Vehicles] Load All Vehicle Models Action",
  props<{ response: any[] }>()
);
// Version
export const getVersions = createAction(
  "[Vehicles] Get All Vehicle Versions Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadVersions = createAction(
  "[Vehicles] Load All Vehicle Versions Action",
  props<{ response: any[] }>()
);
// Motorization
export const getMotorizations = createAction(
  "[Vehicles] Get All Vehicle Motorizations Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadMotorizations = createAction(
  "[Vehicles] Load All Vehicle Motorizations Action",
  props<{ response: any[] }>()
);
// Customer
export const getCustomerVehicleList = createAction(
  "[Vehicles] Get All Vehicle Customers Action",
  props<{ options: any }>()
);
export const loadCustomerVehicleList = createAction(
  "[Vehicles] Load All Vehicle Customers Action",
  props<{ response: any[] }>()
);
//Customer Vehicles
export const getByCustomerVehicleList = createAction(
  "[Vehicles] Get All Vehicle By Customer Action",
  props<{ container: any; options: any }>()
);
export const loadByCustomerVehicleList = createAction(
  "[Vehicles] Load All Vehicle By Customer Action",
  props<{ response: any[] }>()
);
//Vechile Cards
export const getByVehicleCardsList = createAction(
  "[Vehicles] Get All Cards By Vehicle Action",
  props<{ container: any; options: any }>()
);
export const loadByVehicleCardsList = createAction(
  "[Vehicles] Load All Cards By Vehicle Action",
  props<{ response: any[] }>()
);
// Vehicle Tanks
export const saveVehicleTanks = createAction(
  "[Vehicles] Save Vehicles Tanks Action",
  props<{ vehicleCode: string; vehicleTankCodes: any[] }>()
);
export const deleteVehicleTanks = createAction(
  "[Vehicles] Delete Vehicles Tanks Action",
  props<{ vehicleCode: string; vehicleTankCodes: any[] }>()
);
// Odometer Type
export const getOdometerTypeList = createAction(
  "[Vehicles] Get All Odometer Types Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadOdometerTypeVehicleList = createAction(
  "[Vehicles] Load All Odometer Types Action",
  props<{ response: any[] }>()
);
// Consumption Rule
export const getConsumptionRuleList = createAction(
  "[Vehicles] Get All Consumption Rule Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadConsumptionRuleVehicleList = createAction(
  "[Vehicles] Load All Consumption Rule Action",
  props<{ response: any[] }>()
);
// Vehicle Odometers
export const saveVehicleODOs = createAction(
  "[Vehicles] Save Vehicles ODOs Action",
  props<{ vehicleCode: string; vehicleODOsCodes: any[] }>()
);
export const deleteVehicleODOs = createAction(
  "[Vehicles] Delete Vehicles ODOs Action",
  props<{ vehicleCode: string; vehicleODOsCodes: any[] }>()
);
// Vehicle Averages
export const saveVehicleAverages = createAction(
  "[Vehicles] Save Vehicles Averages Action",
  props<{ vehicleCode: string; vehicleAveragesCodes: any[] }>()
);
export const deleteVehicleAverages = createAction(
  "[Vehicles] Delete Vehicles Averages Action",
  props<{ vehicleCode: string; vehicleAveragesCodes: any[] }>()
);
export const getVehicleAverages = createAction(
  "[Vehicles] Get Vehicles Averages Action",
  props<{ vehicleCode: string }>()
);
export const loadVehicleAverages = createAction(
  "[Vehicles] Load Vehicles Averages Action",
  props<{ response: any }>()
);
export const getByTransactionsVehicleList = createAction(
  "[Vehicles] Get All Transactions by Vehicle Action",
  props<{ options: any }>()
);
export const loadByTransactionsVehicleList = createAction(
  "[Vehicles] Load All Transactions by Vehicle Action",
  props<{ response: any[] }>()
);
export const getVehicleExcelList = createAction(
  "[Vehicles] Get All Vehicle Excel List Action",
  props<{ options: any }>()
);
export const loadVehicleExcelList = createAction(
  "[Vehicles] Load All Vehicle Excel List Action",
  props<{ response: any[] }>()
);
export const resetVehiclesState = createAction('[Vehicles] Reset Vehicles State Action');
export const resetCreation = createAction("[Vehicles] Reset Creation Action");
